import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from './Button';
import BasketItem from './BasketItem';
import TotalPremiumBanner from './TotalPremiumBanner';
import ActivityIndicator from './forms/ActivityIndicator';
import { MotorService } from '../services/motorService';
import { getAllHomeContents, createHomeContent } from '../services/buildingAndContentsService';
import { Helpers } from '../utilities/helpers';
import { Redirect } from 'react-router-dom';
import { basketHelpers } from '../utilities/basketHelpers';
import Alert from './forms/Alert';
import ConfirmationPopup from './forms/ConfirmationPopup';
import PropertyTypeSelector from './home-contents/PropertyTypePopup';
import(/* webpackPrefetch: true */ 'bootstrap/dist/css/bootstrap.min.css');
import { productTypes } from '../utilities/enums';

const Overlay = (props) => {
  const [isRemovingBasketItem, setIsRemovingBasketItem] = useState(false);
  const [basket, setBasket] = useState([]);
  const [basketCount, setBasketCount] = useState(0);
  const [comprehensivePremiumTotal, setComprehensivePremiumTotal] = useState(0);
  const [lowMileagePremiumTotal, setLowMileagePremiumTotal] = useState(0);
  const [redirect, setRedirect] = useState(false);
  const [vehicle, setVehicle] = useState({});
  const [homeId, setHomeId] = useState({});
  const [showRemoveVehiclePopUup, setShowRemoveVehiclePopup] = useState(false);
  const [vehicleToRemove, setVehicleToRemove] = useState({});
  const [showRemoveHomeContentPopup, setShowRemoveHomeContentPopup] = useState(false);
  const [homeToRemove, setHomeToRemove] = useState({});
  const [user, setUser] = useState('');
  const [redirectToHomeDetails, setRedirectToHomeDetails] = useState(false);
  const [itemToRemoveType, setItemToRemoveType] = useState('');
  const [showAddPropertyPopup, setShowAddPropertyPopup] = useState(false);
  const [selectedPropertyType, setSelectedPropertyType] = useState(null);
  const [containsMotorItem, setContainsMotorItem] = useState(true)

  const {
    product,
    placement,
    showSideMenu,
    onSideMenuClose,
    loading,
    basketItems,
    updateBasketCount,
    onAddVehicleButtonPress,
  } = props;

  const LOW_MILEAGE_PERCENTAGE = 0.71

  const getBasketCount = (premiumObject) => {
    return Object.values(premiumObject).length;
  };

  const isMotorInsurance = product === productTypes.motor;
  const isHomeInsurance = product === 'home-insurance';

  //get user
  useEffect(() => {
    async function fetchUser() {
      const authUser = await Helpers.getAuthUser();
      setUser(authUser);
    };

    fetchUser();
  }, []);

  useEffect(() => {
    async function setBasketInStorage() {
      if (basketItems) {
        await Helpers.setInStorage(
          'allProductsInsuranceCart',
          JSON.stringify(basketItems)
        );
      }
    }

    setBasketInStorage()
  }, [basketItems]);

  useEffect(() => {
    async function getBasketInStorage() {
      const basketStr = await Helpers.getInStorage('allProductsInsuranceCart');
      if (isMotorInsurance) {
        const currentVehicle = await Helpers.getSavedVehicle();
        setVehicle(currentVehicle);
      } else if (isHomeInsurance) {
        const currentHome_Id = await Helpers.getInStorage('home_content_id');
        setHomeId(currentHome_Id);
      }

      if (basketStr) {
        const basketObj = JSON.parse(basketStr);
        const basketItemCount = getBasketCount(basketObj);
        const basketItemArray = Object.values(basketObj)

        const premiumTotals = Helpers.getBasketPremiumTotals(basketItemArray);
        setComprehensivePremiumTotal(
          parseFloat(premiumTotals.comprehensive).toFixed(2)
        );
        setLowMileagePremiumTotal(
          parseFloat(premiumTotals.lowMileage).toFixed(2)
        );
        setBasket(basketItemArray);

        setBasketCount(basketItemCount);

        //Check if basket contains motor item
        const hasMotorItem = basketItemArray.some((item) => item.type === productTypes.motor)
        setContainsMotorItem(hasMotorItem)

      } else {
        setComprehensivePremiumTotal(0);
        setLowMileagePremiumTotal(0);
        setBasket([]);
        setBasketCount(0);
      }
    }

    getBasketInStorage()
  }, [loading, basketItems, isRemovingBasketItem]);

  const addNewVehicle = async (removeCurrentVehicle) => {
    try {
      await onAddVehicleButtonPress({ redirectPath: '/dashboard', removeCurrentVehicle });
    } catch (error) {
      console.error('Error during redirection:', error);
    }
    await Helpers.removeFromStorage('vehicle')
    const vehiclesResponse = await MotorService.getVehicles({ insured: false })
    const vehicles = vehiclesResponse.success ? vehiclesResponse.data : null
    await Helpers.removeFromStorage('numberPlate')
    await Helpers.removeFromStorage('vehicle-image')

    if (vehicles) {
      await Helpers.setInStorage('vehicles', JSON.stringify(vehicles));
    }
  };

  const handlePropertyTypeChange = (value) => {
    setSelectedPropertyType(value);
  }

  const CreateNewHomeContent = async () => {
    const user = await Helpers.getAuthUser();

    //Add sales-agent data to users home-contents
    const salesAgent = await Helpers.getInStorage('sales_agent', true)
    let agent

    if (salesAgent) {
      agent = JSON.parse(salesAgent)
    }

    const firstName = user.first_name
    const lastName = user.last_name
    // format user sale data
    const addedByData = Helpers.formatUserInfo(agent, user, null) //set dealership to null
    const contents_name = `${firstName.replace(' ', '_')}_${lastName.replace(' ', '_')}_${selectedPropertyType}`

    const data = {
      user_id: user.id,
      name: contents_name,
      property_type: selectedPropertyType,
      added_by: addedByData
    }

    const response = await createHomeContent(data)
    if (!response || !response.success) {
      setIsSubmitting(false);
      return Alert.alert(
        'On No!',
        response?.error?.message || 'There was a problem saving your information. Please try again later.'
      );
    }
    if (response) {
      await Helpers.removeFromStorage('home_content_id');
      await Helpers.setInStorage('home_content_id', response?.data?._id)
    }
  }

  const addNewHomeContents = async () => {
    setShowAddPropertyPopup(true);
    onSideMenuClose();
  };

  const removeVehicleFromQuote = async (vehicleReg, vehicleId) => {
    setIsRemovingBasketItem(true);
    const filteredBasket = await basketHelpers.removeVehicleFromQuote(
      vehicleReg,
      vehicleId
    );
    if (filteredBasket) {
      setBasket(filteredBasket);
      updateBasketCount(filteredBasket.length);
      addNewVehicle();
    }
    setIsRemovingBasketItem(false);
  };

  const removeHomeContentsFromQuote = async (ObjectNo) => {
    setIsRemovingBasketItem(true);
    const filteredBasket = await basketHelpers.removeHomeContentFromQuote(ObjectNo);
    if (filteredBasket) {
      setBasket(filteredBasket);
      updateBasketCount(filteredBasket.length);
    }
    setIsRemovingBasketItem(false);
  };

  const reviewVehicleDetails = async (vehicleId) => {
    const vehiclesResponse = await MotorService.getVehicles({ insured: false });
    const vehicles = vehiclesResponse.success ? vehiclesResponse.data : null;
    if (vehicles && vehicles.length) {
      let matchedVehicle = vehicles.find((vehicle) => vehicle.id == vehicleId);
      Helpers.setInStorage('vehicle', JSON.stringify(matchedVehicle));
      await Helpers.setInStorage(
        'vehicle-image',
        matchedVehicle.creativeImage ?? ''
      );
      setRedirect(true);
    }
  };

  const reviewHomeContentsDetails = async (HomeId) => {
    const HomeContentsResponse = await getAllHomeContents(user.id);
    const homes = HomeContentsResponse.success ? HomeContentsResponse.data : null;
    if (homes && homes?.length) {
      const quotedHomeContents = []
      homes.forEach((home) => {
        if (home.property_address && !home.insured && !home.deleted && !home.removed_from_quote) {
          quotedHomeContents.push(home)
        }
      })
      let matchedhome = quotedHomeContents.find((home) => home._id === HomeId);
      let matchedHomeId = matchedhome._id;
      Helpers.setInStorage('home_content_id', matchedHomeId);
      setRedirectToHomeDetails(true);
    }
  };

  const handlePressRemoveVehicle = async (item) => {
    if (vehicle.registration === item.registration) {
      onSideMenuClose();
      return Alert.alert(
        'Please note',
        'You are about to remove the vehicle that is currently being displayed on screen.',
        [
          {
            text: 'Cancel',
            style: 'cancel',
          },
          {
            text: 'Remove Vehicle',
            onClick: async () => {
              await removeVehicleFromQuote(item.registration, item.id);
            },
          },
        ]
      );
    }

    onSideMenuClose();
    setVehicleToRemove({
      registration: item.registration,
      id: item.id,
      image: item.image,
    });
    setShowRemoveVehiclePopup(true);
  };

  const handlePressRemoveHomeContentItem = async (item) => {


    if (item.id === homeId && user.id) {
      onSideMenuClose();
      return Alert.alert(
        'Please note',
        'You are about to remove the home that is currently being displayed on screen.',
        [
          {
            text: 'Cancel',
            style: 'cancel',
          },
          {
            text: 'Remove Home',
            onClick: async () => {
              await removeHomeContentsFromQuote(item.iwyze_object_no);
            },
          },
        ]
      );
    }

    onSideMenuClose();
    setHomeToRemove({ objectNo: item.iwyze_object_no });
    setShowRemoveHomeContentPopup(true);
  };

  if (redirect) {
    return <Redirect to="/car-insurance/dashboard" />;
  }

  if (redirectToHomeDetails) {
    return <Redirect to="/home-contents-insurance/home-details" />;
  }

  return (
    <>
      <ConfirmationPopup
        type={itemToRemoveType}
        visible={showRemoveVehiclePopUup}
        image={vehicleToRemove.image}
        title="Removing a Vehicle?"
        content={`${user && user.first_name ? user.first_name + ' are' : 'Are'
          } you sure you want to remove this car from your shopping cart? Please note, you can re-add this later.`}
        buttons={[
          {
            title: 'No thanks',
            color: 'white',
            onClick: () => {
              setShowRemoveVehiclePopup(false);
            },
          },
          {
            title: 'Yes',
            onClick: async () => {
              setShowRemoveVehiclePopup(false);
              await removeVehicleFromQuote(
                vehicleToRemove.registration,
                vehicleToRemove.id
              );
              setVehicleToRemove({});
            },
          },
        ]}
      />
      <ConfirmationPopup
        type={itemToRemoveType}
        visible={showRemoveHomeContentPopup}
        title="Removing this Home and its Contents?"
        content={`${user && user.first_name ? user.first_name + ' are' : 'Are'
          } you sure you want to remove this home and its contents from your shopping cart? Please note, you can re-add this later.`}
        buttons={[
          {
            title: 'No thanks',
            color: 'white',
            onClick: () => {
              setShowRemoveHomeContentPopup(false);
            },
          },
          {
            title: 'Yes',
            onClick: async () => {
              setShowRemoveHomeContentPopup(false);
              await removeHomeContentsFromQuote(homeToRemove.objectNo);
              setHomeToRemove({});
            },
          },
        ]}
      />
      <PropertyTypeSelector
        visible={showAddPropertyPopup}
        onClickCancel={() => setShowAddPropertyPopup(false)}
        onClickContinue={async () => {
          await CreateNewHomeContent()
          setShowAddPropertyPopup(false)
          setRedirectToHomeDetails(true);
        }}
        onPropertyTypeChange={handlePropertyTypeChange}
        isDarkMode={false}
      />
      <Offcanvas
        show={showSideMenu || isRemovingBasketItem}
        placement={placement}
        onHide={() => onSideMenuClose()}
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <div className="off-canvas-side-menu-wrapper off-canvas-side-menu-wrapper--is-margin-bottom">
            {basketCount === 0 ? (
              <div>
                <h4 className="off-canvas-wrapper-heading">
                  You have no Vehicles or Home and Contents in your cart
                </h4>
                <p className="off-canvas-wrapper-sub-heading">
                  Once you view a quote for a Vehicle or Home Contents it will be added to your
                  cart.
                </p>
                <center> {/* //fix button styling and spacing for all media screen sizes */}
                  {isMotorInsurance && <Button title="Add Vehicle" onClick={() => addNewVehicle()} />}
                  {isHomeInsurance && <Button title="Add Home Contents" onClick={() => addNewHomeContents()} />}
                </center>
              </div>
            ) : (
              <div className="off-canvas-basket-full-width">
                <h1 className="off-canvas-wrapper-heading-main">
                  My Shopping Cart
                </h1>
                <h4 className="off-canvas-wrapper-heading">
                  You have the following item(s) in your cart
                </h4>
                {loading ? (
                  <center className="basket-loader-mt-20">
                    <ActivityIndicator color="#000000" />
                  </center>
                ) : (
                  <div className="basket-ledger-wrapper basket-ledger-wrapper--is-full-height">
                    {basket?.length > 0 ? (basket.map((item, index) => {
                      if (item) {
                        let hasCarHire = false
                        if (item.options) {
                          hasCarHire = item.options.hasCarHire
                        }
                        return (
                          <BasketItem
                            type={item.type}
                            key={index}
                            description={item.description}
                            loading={isRemovingBasketItem}
                            onPressReview={() => {
                              if (item.type === productTypes.motor) {
                                reviewVehicleDetails(item.id)
                              } else if (item.type === productTypes.homeContents) {
                                reviewHomeContentsDetails(item.id)
                              }
                            }}
                            onPressRemove={() => {
                              if (item.type === productTypes.motor) {
                                setItemToRemoveType(productTypes.motor);
                                handlePressRemoveVehicle(item);
                              } else if (item.type === productTypes.homeContents) {
                                setItemToRemoveType(productTypes.homeContents);
                                handlePressRemoveHomeContentItem(item);
                              }
                            }}
                            registration={item.registration}
                            lowmileagePremium={item.low_mileage_display_premium ? item.low_mileage_display_premium : ((item.comprehensive_premium + (item.credit_shortfall_premium || 0) + (hasCarHire ? item.car_hire_premium : 0)) * LOW_MILEAGE_PERCENTAGE)}
                            comprehensivePremium={item.display_premium ? item.display_premium : (item.comprehensive_premium + (item.credit_shortfall_premium || 0) + (hasCarHire ? item.car_hire_premium : 0))}
                            image={item.image}
                          />
                        );
                      }
                    })) : (
                      <p>No items in the cart.</p>
                    )}
                  </div>
                )}
                <div className="off-canvas-basket-actions-wrapper">
                  <TotalPremiumBanner
                    backgroundColor={'#67c9d0'}
                    lowMileagePremiumTotal={lowMileagePremiumTotal}
                    comprehensivePremiumTotal={comprehensivePremiumTotal}
                    hideAllMileageTotals={!containsMotorItem}
                  />
                  {loading ? (
                    <center className="off-canvas-loader-wrapper">
                      <ActivityIndicator color="#000000" />
                      <p className="off-canvas-loading-text">Saving Quote...</p>
                    </center>
                  ) : (
                    <div className="off-canvas-basket-buttons-wrapper">
                      {isMotorInsurance && <Button
                        style={{ margin: 0 }}
                        title="Add Additional Vehicle"
                        color={'white'}
                        onClick={() => addNewVehicle()}
                      />}
                      {isHomeInsurance && <Button
                        style={{ margin: 0 }}
                        title="Add Additional Home Contents"
                        color={'white'}
                        onClick={() => {
                          addNewHomeContents()
                        }}
                      />}
                      <Button
                        style={{ margin: 0 }}
                        title="Continue"
                        onClick={() => onSideMenuClose()}
                      />
                    </div>
                  )}
                  {/* <Button style={{ margin: 0 }} title="Continue" onClick={() => console.log('continue')} /> */}
                </div>
              </div>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Overlay;
